import { useCallback, useContext } from 'react';
import { AppContext } from '../../context/AppContext';
import { OrderConfirmationPaymentContext } from '../../context/OrderConfirmationPaymentContext';
import { api } from '../../services/api';
import PaymentProviderDisconnectModal from './PaymentProviderDisconnectModal';

const StripeDisconnectModal = ({ open, onClose, onSuccess }) => {
  const { storeId } = useContext(AppContext);
  const { refetchPaymentProviders } = useContext(OrderConfirmationPaymentContext);

  const onDisconnect = useCallback(async () => {
    if (storeId == null) {
      throw new Error('Store is not available.');
    }
    await api.deactivateStripe(storeId);
    await refetchPaymentProviders();
  }, [storeId, refetchPaymentProviders]);

  return (
    <PaymentProviderDisconnectModal
      open={open}
      onClose={onClose}
      onSuccess={onSuccess}
      providerLabel="Stripe"
      onDisconnect={onDisconnect}
    />
  );
};

export default StripeDisconnectModal;
